module.exports = __webpack_public_path__ + "static/ally-GRP-70787aa3344b0d57af8b555672f9ff5f.png";